package one.healthium.pilates

import kotlin.String

internal object BuildKonfig {
  public val BUILD_FLAVOUR: String = "Prod"
}
